export const FILTER_OPTIONS_MAP = {
  "PS Full (A,V,D)": "PS Full",
  "PS Lite(A,V)": "PS Lite (A V)",
  "PS Lite(A,D)": "PS Lite (A D)",
  "PS Nano(A)": "PS Nano",
  "Excluded channels": "Excluded channels",
};

export const FILTER_OPTIONS = Object.keys(FILTER_OPTIONS_MAP);

export const DEFAULT_FILTERS = ["PS Full (A,V,D)", "PS Lite(A,V)", "PS Lite(A,D)", "PS Nano(A)"];

export const shouldHideDigitization = (appliedFilters) => {
  if (!appliedFilters || appliedFilters.length === 0) return false;

  const hasOnlyPsNano = appliedFilters.length === 1 && appliedFilters[0] === "PS Nano(A)";
  const hasOnlyPsLiteAv = appliedFilters.length === 1 && appliedFilters[0] === "PS Lite(A,V)";
  const hasNanoAndLiteAv = appliedFilters.length === 2 &&
    appliedFilters.includes("PS Nano(A)") &&
    appliedFilters.includes("PS Lite(A,V)");

  return hasOnlyPsNano || hasOnlyPsLiteAv || hasNanoAndLiteAv;
};

export const shouldHideVisibility = (appliedFilters) => {
  if (!appliedFilters || appliedFilters.length === 0) return false;

  const hasOnlyPsNano = appliedFilters.length === 1 && appliedFilters[0] === "PS Nano(A)";
  const hasOnlyPsLiteAd = appliedFilters.length === 1 && appliedFilters[0] === "PS Lite(A,D)";
  const hasNanoAndLiteAd = appliedFilters.length === 2 &&
    appliedFilters.includes("PS Nano(A)") &&
    appliedFilters.includes("PS Lite(A,D)");

  return hasOnlyPsNano || hasOnlyPsLiteAd || hasNanoAndLiteAd;
};
 